// authkit-ui appends `?authUser=<json>&orgId=…` on its redirect into the SPA.
// authUser carries the user's email and name, so the params leave the URL
// before Sentry, the router or analytics read it; the values stay in memory.
const HANDOFF_PARAMS = ["authUser", "orgId"] as const;

export type AuthHandoff = { authUser: string; orgId: string | null };

let handoff: AuthHandoff | null = null;

export function stripAuthHandoffFromUrl(): void {
  const url = new URL(window.location.href);
  if (!HANDOFF_PARAMS.some((param) => url.searchParams.has(param))) return;

  const authUser = url.searchParams.get("authUser");
  if (authUser !== null) {
    handoff = { authUser, orgId: url.searchParams.get("orgId") };
  }
  HANDOFF_PARAMS.forEach((param) => url.searchParams.delete(param));
  window.history.replaceState(
    window.history.state,
    "",
    url.pathname + url.search + url.hash,
  );
}

export function getAuthHandoff(): AuthHandoff | null {
  return handoff;
}

export function __resetAuthHandoffForTests(): void {
  handoff = null;
}
